var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#2B65CF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2224 25.33C14.961 25.33 13.9197 25.0073 13.0984 24.362C12.2844 23.7167 11.705 22.844 11.3604 21.744L14.3084 21.04C14.3744 21.4433 14.587 21.7953 14.9464 22.096C15.3057 22.3893 15.687 22.536 16.0904 22.536C16.369 22.536 16.666 22.459 16.9814 22.305C17.304 22.151 17.535 21.9053 17.6744 21.568C17.7624 21.3553 17.8137 21.095 17.8284 20.787C17.843 20.479 17.8504 20.1233 17.8504 19.72V9.16H20.8864V19.72C20.8864 20.226 20.8827 20.666 20.8754 21.04C20.8754 21.414 20.8387 21.766 20.7654 22.096C20.6994 22.4187 20.5637 22.756 20.3584 23.108C19.911 23.8853 19.328 24.45 18.6094 24.802C17.8907 25.154 17.095 25.33 16.2224 25.33Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.75 39C24.1525 39 17 46.1525 17 47.75C17 46.1525 9.84751 39 8.25 39C9.84751 39 17 31.8475 17 30.25C17 31.8475 24.1525 39 25.75 39Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.75 59C49.8745 59 37 71.8745 37 74.75C37 71.8745 24.1255 59 21.25 59C24.1255 59 37 46.1255 37 43.25C37 46.1255 49.8745 59 52.75 59Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJd);
export default __webpack_public_path__ + "static/media/jd.b8eaedf72d455c445db62d8c7c279216.svg";
export { ForwardRef as ReactComponent };